import { Menu } from 'components/Header/types'
import { PlataformasProps } from 'pages/Home/types'
import PlataformaService from 'services/PlataformaService'

interface Item {
  id: number
  urn: string
  nome: string
  descricao: string
  codigoIconeLight: string
  codigoIconeDark: string
}

interface MenuDeItens {
  id: number
  nome: string
  descricao: string
  codigoIconeLight: string
  codigoIconeDark: string
  filhos: Item[]
}

const getMenusPersonalizados = async (
  codPlataforma: string | undefined
): Promise<Menu[]> => {
  const response: MenuDeItens[] = await PlataformaService.getMenusPlataforma(
    codPlataforma
  )
  if (response) {
    const menus = response.map(menu => {
      return {
        id: menu.id,
        label: menu.nome,
        iconeLight: menu.codigoIconeLight,
        iconeDark: menu.codigoIconeDark,
        isPersonalizado: true,
        itens: menu.filhos.map(
          ({ urn, id, nome, codigoIconeLight, codigoIconeDark }) => ({
            id: id,
            label: nome,
            rota: `/${urn}`,
            iconeLight: codigoIconeLight,
            iconeDark: codigoIconeDark
          })
        )
      }
    })
    return menus
  } else {
    return []
  }
}

const getPlataformasMenu = async () => {
  const listaPlataformas: PlataformasProps[] =
    await PlataformaService.getPlataformas({
      ignorarPermissao: true,
      buscarPrivados: false
    })
  if (listaPlataformas) {
    return listaPlataformas.map(plataforma => {
      return {
        id: plataforma.id,
        rota: `/plataformas/${plataforma.codigo}`,
        label: plataforma.nome,
        isPlatform: true
      }
    })
  } else {
    return []
  }
}

export { getPlataformasMenu, getMenusPersonalizados }
